import React from "react";

const NotFound = () => {
  return <span>Not Found</span>;
};

export default NotFound;
